import { render } from "./Textsearch.vue?vue&type=template&id=2af8ac60"
import script from "./Textsearch.vue?vue&type=script&lang=ts"
export * from "./Textsearch.vue?vue&type=script&lang=ts"

const cssModules = script.__cssModules = {}
import style0 from "./Textsearch.vue?vue&type=style&index=0&id=2af8ac60&module=true&lang=css"
cssModules["$style"] = style0
script.render = render

export default script